import { useMemo } from 'react';
import { ClinicalAppPermission, readCrmPermissions } from '@packages/core-shared';
import { useSessionClaims } from './useSessionClaims';

/**
 * The Descope CRM permissions of the signed-in user, read off the Descope
 * session token (PPL-3826). The API authorizes on the same token, so the UI
 * and the backend gate on one set — and it is the full set, not the handful
 * the Firebase subscription token carries.
 */
export const usePermissions = (): string[] => {
  // Memoise on the permissions claim itself, not the whole claims object,
  // which changes identity on every session refresh even when the permissions
  // have not.
  const permissionsClaim = useSessionClaims()?.permissions;

  return useMemo(() => readCrmPermissions(permissionsClaim), [permissionsClaim]);
};

/** Whether the signed-in user holds `permission`. */
export const useHasPermission = (permission: ClinicalAppPermission): boolean => usePermissions().includes(permission);
